export const colorsMap = [
    {
        name: 'default',
        primaryColor: '#2970FF',
        dark_subColor: '#B3945E',
        light_subColor: '#ffffff',
        dark_textColor: '#ffffff',
        light_textColor: '#2970FF',
        dark_headBGColor: '#2970FF',
        light_headBGColor: '#ffffff',
        headMenuActiveColor: '#bf984a',
        dark_activeBGColor: '#f9f9f9',
        light_activeBGColor: '#f1f2f6',
        dark_hoveBGColor: '#f9f9f9',
        light_hoveBGColor: '#f1f2f6',
        hoverColor: '#5291FF',
        highlightColor: '#2970ff',
        borderColor: '#5291ff',
        shadowColor: 'rgba(41, 112, 255, 0.2)',
        headerMenuHoverColor: '#0076F6' //头部文字hover颜色
    },
    {
        name: 'golden',
        primaryColor: '#D1AD60',
        dark_subColor: '#B3945E',
        light_subColor: '#fff',
        dark_textColor: '#ffffff',
        light_textColor: '#D1AD60',
        dark_headBGColor: '#D1AD60',
        light_headBGColor: '#ffffff',
        headMenuActiveColor: '#bf984a',
        dark_activeBGColor: '#f9f9f9',
        light_activeBGColor: '#faf6ef',
        dark_hoveBGColor: '#f9f9f9',
        light_hoveBGColor: '#faf6ef',
        hoverColor: '#C2A97E',
        highlightColor: '#D1AD60',
        borderColor: '#dec68a',
        shadowColor: 'rgba(209, 173, 96, 0.2)',
        headerMenuHoverColor: '#0076F6' //头部文字hover颜色
    },
    {
        name: 'red',
        primaryColor: '#E05251',
        dark_subColor: '#BB4443',
        light_subColor: '#ffffff',
        dark_textColor: '#ffffff',
        light_textColor: '#E05251',
        dark_headBGColor: '#E05251',
        light_headBGColor: '#ffffff',
        headMenuActiveColor: '#d13d3c',
        dark_activeBGColor: '#f9f9f9',
        light_activeBGColor: '#fdf6f6',
        dark_hoveBGColor: '#f9f9f9',
        light_hoveBGColor: '#fdf6f6',
        hoverColor: '#C86968',
        highlightColor: '#E05251',
        borderColor: '#ed7f7b',
        shadowColor: 'rgba(224, 82, 81, 0.2)',
        headerMenuHoverColor: '#0076F6' //头部文字hover颜色
    },
    {
        name: 'green',
        primaryColor: '#18BFA4',
        dark_subColor: '#0D8F7F',
        light_subColor: '#fff',
        dark_textColor: '#ffffff',
        light_textColor: '#18BFA4',
        dark_headBGColor: '#18BFA4',
        light_headBGColor: '#ffffff',
        headMenuActiveColor: '#3cd0ad',
        dark_activeBGColor: '#f9f9f9',
        light_activeBGColor: '#f3fcfa',
        dark_hoveBGColor: '#f9f9f9',
        light_hoveBGColor: '#f3fcfa',
        highlightColor: '#18BFA4',
        hoverColor: '#3DA598',
        borderColor: '#3bccaf',
        shadowColor: 'rgba(24, 191, 164, 0.2)',
        headerMenuHoverColor: '#0076F6' //头部文字hover颜色
    },
    {
        name: 'blue',
        primaryColor: '#0076F6',
        dark_subColor: '#255492',
        light_subColor: '#fff',
        dark_textColor: '#ffffff',
        light_textColor: '#0076F6',
        dark_headBGColor: '#0076F6',
        light_headBGColor: '#ffffff',
        headMenuActiveColor: '#238bfe',
        dark_activeBGColor: '#f9f9f9',
        light_activeBGColor: '#f2f8fe',
        dark_hoveBGColor: '#f9f9f9',
        light_hoveBGColor: '#f2f8fe',
        hoverColor: '#5076A7',
        highlightColor: '#0076F6',
        borderColor: '#2997ff',
        shadowColor: 'rgba(0, 118, 246, 0.2)',
        headerMenuHoverColor: '#0076F6' //头部文字hover颜色
    },
    {
        name: 'purple',
        primaryColor: '#6F76FA',
        dark_subColor: '#44467C',
        light_subColor: '#fff',
        dark_textColor: '#ffffff',
        light_textColor: '#6F76FA',
        dark_headBGColor: '#6F76FA',
        light_headBGColor: '#ffffff',
        headMenuActiveColor: '#575df9',
        dark_activeBGColor: '#f9f9f9',
        light_activeBGColor: '#f8f8ff',
        dark_hoveBGColor: '#f9f9f9',
        light_hoveBGColor: '#f8f8ff',
        hoverColor: '#696B96',
        highlightColor: '#6F76FA',
        borderColor: '#99a1ff',
        shadowColor: 'rgba(111, 118, 250, 0.2)',
        headerMenuHoverColor: '#0076F6' //头部文字hover颜色
    },
    {
        name: 'black',
        primaryColor: '#2F323B',
        dark_subColor: '#1F2024',
        light_subColor: '#fff',
        dark_textColor: '#0076F6',
        light_textColor: '#2F323B',
        dark_headBGColor: '#2F323B',
        light_headBGColor: '#fff',
        headMenuActiveColor: '#1F2024',
        dark_activeBGColor: '#f9f9f9',
        light_activeBGColor: '#f6f6f6',
        dark_hoveBGColor: '#f9f9f9',
        light_hoveBGColor: '#f4f5f5',
        hoverColor: '#2F323B',
        highlightColor: '#0076F6',
        borderColor: '#2997ff',
        shadowColor: 'rgba(0, 118, 246, 0.2)',
        headerMenuHoverColor: '#0076F6' //头部文字hover颜色
    }
];
